import Grid from "@mui/material/Grid";
import Toolbar from "@mui/material/Toolbar";
import { sideBarNavWidth, sideBarNavMiniWidth } from "../../../assets/theme/generalTheme";

interface Props {
  children: any;
  openSideBarNav: boolean;
}
function MainContent(props: Props) {
  return (
    <main
      style={{
        padding: "15px 15px",
        minHeight: "100vh",
      }}
    >
      <Toolbar />
      <Grid
        container
        sx={[
          (theme) => ({
            transition: theme.transitions.create(["width", "margin"], {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.leavingScreen,
            }),
          }),
          props.openSideBarNav
            ? {
                marginLeft: `${sideBarNavWidth}px`,
                width: `calc(100% - ${sideBarNavWidth}px)`,
              }
            : {
                marginLeft: `${sideBarNavMiniWidth}px`,
                width: `calc(100% - ${sideBarNavMiniWidth}px)`,
              },
        ]}
      >
        {props.children}
      </Grid>
    </main>
  );
}

export default MainContent;
